import { TCustomField } from 'src/components/company/programs/createProgram';

export const programDetailsInitialFields: TCustomField[] = [
  {
    id: 'aboutEvent',
    type: 'textEditor',
    label: 'About the Event',
    placeholder: 'Description',
    values: ''
  }
];
